import axios   from "axios";
import Toaster from "../toaster";

export default class AdfProfile
{
    constructor ()
    {
        this.createClosure()
        this.bindEvents()
    }

    createClosure ()
    {
        this.fctOnModify         = this.onModify.bind( this );
        this.fctOnCancel         = this.onCancel.bind( this );
        this.fctOnSave           = this.onSave.bind( this );
        this.fctOnSwitch         = this.onSwitch.bind( this );
        this.fctDeleteAccount    = this.showDeleteAccount.bind( this );
        this.fctOnAccountDeleted = this.onAccountDeleted.bind( this );
    }

    bindEvents ()
    {
        Array.from( document.querySelectorAll( "[data-btn-type=edit]" ) )
            .forEach( btn =>
            {
                btn.addEventListener( "click", this.fctOnModify )
            } )

        Array.from( document.querySelectorAll( "[data-btn-type=cancel]" ) )
            .forEach( btn =>
            {
                btn.addEventListener( "click", this.fctOnCancel )
            } )

        Array.from( document.querySelectorAll( "[data-btn-type=save]" ) )
            .forEach( btn =>
            {
                btn.addEventListener( "click", this.fctOnSave )
            } )

        let switchNewsletter = document.querySelector( "#newsletter" );
        switchNewsletter.addEventListener( "change", this.fctOnSwitch );

        let btnDeleteAccount = document.querySelector( "[data-btn-delete-account]" );
        btnDeleteAccount.addEventListener( "click", this.fctDeleteAccount );

        window.addEventListener( "account-delete", this.fctOnAccountDeleted );

    }


    onModify ( e )
    {
        let btn         = e.target;
        let groupToHide = btn.closest( "[data-type=display]" );

        this.toggleField( groupToHide, "display", "edit" )

    }

    async onSwitch ( e )
    {

        let key   = e.target.id;
        let value = e.target.checked;

        let options    = { "form" : "inscription" };
        options[ key ] = value;


        let response = await axios.post( "/endpoints/user", options );
        let data     = response.data;

        Toaster.fire( data.toaster )

    }

    async onAccountDeleted ( e )
    {
        await Toaster.fire( e.detail.toaster );

        window.location.href = "/#type=suppression-du-compte";
    }

    async onSave ( e )
    {
        let btn       = e.target;
        let groupEdit = btn.closest( "[data-type=edit]" );

        //this.toggleField(groupToHide,  "edit", "display")

        if ( !this.hasChanged( groupEdit ) )
        {
            this.removeError( groupEdit );
            this.toggleField( groupEdit, "edit", "display" )
        } else
        {
            let { newValue, key } = this.getFieldsValues( groupEdit );

            let options    = { "form" : "inscription" };
            options[ key ] = newValue;

            let response = await axios.post( "/endpoints/user", options );
            let data     = response.data;

            if ( data.success )
            {
                this.setFieldValue( groupEdit, key, newValue );
                this.removeError( groupEdit );
                this.toggleField( groupEdit, "edit", "display" )

                Toaster.fire( data.toaster )
            } else
            {
                this.setErrors( data, groupEdit );
            }
        }


    }

    setErrors ( data, groupEdit )
    {

        for ( let strKey in data.errors )
        {
            let error = groupEdit.querySelector( "#error_" + strKey );

            error.classList.remove( "d-none" );
            error.textContent = data.errors[ strKey ];
        }
    }

    removeError ( groupEdit )
    {
        let error = groupEdit.querySelector( "[data-type=error]" );

        error.classList.add( "d-none" );
        error.textContent = "";
    }

    hasChanged ( groupEdit )
    {
        let { newValue, oldValue } = this.getFieldsValues( groupEdit );
        return newValue !== oldValue
    }

    getFieldsValues ( group )
    {
        let strId   = group.attributes[ "id" ].value.replace( "edit_", "" );
        let sibling = document.querySelector( "#display_" + strId );
        let field   = group.querySelector( "#" + strId );

        let newValue;
        let oldValue;

        if ( [ "email", "fonction", "password", "etablissement" ].includes( strId ) )
        {
            newValue = field.value;
            oldValue = sibling.querySelector( "[data-field-type=display]" ).attributes[ "data-value" ].value;
        } else if ( [ "ordres" ].includes( strId ) )
        {
            let strCheckBoxOrdre = Array.from( document.querySelectorAll( "[type=checkbox]" ) )
                .filter( cb => cb.attributes[ "id" ].value.substring( 0, 5 ) === "ordre" )
                .filter( cb => cb.checked )
                .map( cb => cb.value )
                .join( "," );


            newValue = strCheckBoxOrdre;
            oldValue = sibling.querySelector( "[data-field-type=display]" ).attributes[ "data-value" ].value;


        }

        return { newValue, oldValue, key : strId };
    }

    setFieldValue ( group, strId, value )
    {

        let sibling = document.querySelector( "#display_" + strId );

        let field                              = sibling.querySelector( "[data-field-type=display]" );
        field.attributes[ "data-value" ].value = value;

        if ( [ "email", "etablissement" ].includes( strId ) )
        {
            field.textContent = value;
        } else if ( [ "fonction" ].includes( strId ) )
        {


            // we need to figure out the option's label based on its value
            const select         = group.querySelector( 'select' );
            const selectedOption = select.querySelector( 'option[value="' + value + '"]' );

            const text        = selectedOption ? selectedOption.textContent : value;
            field.textContent = text;
        } else if ( [ "password" ].includes( strId ) )
        {
            field.attributes[ "data-value" ].value = "";
            field.textContent                      = "********";
        } else if ( [ "ordres" ].includes( strId ) )
        {
            Array.from( document.querySelectorAll( "[type=checkbox]" ) )
                .filter( cb => cb.attributes[ "id" ].value.substring( 0, 5 ) === "ordre" )
                .forEach( cb =>
                {
                    let strId     = cb.value;
                    let isChecked = cb.checked
                    let li        = document.querySelector( `#li_${strId}` );

                    isChecked ? li.classList.remove( "d-none" ) : li.classList.add( "d-none" );
                } )
        }
    }

    onCancel ( e )
    {
        let btn         = e.target;
        let groupToHide = btn.closest( "[data-type=edit]" );

        this.toggleField( groupToHide, "edit", "display" )

    }

    toggleField ( groupToHide, strHide, strShow )
    {
        //TOGGLE BETWEEN THE DISPLAY MODE and THE EDIT MODE
        groupToHide.classList.add( "d-none" );

        let strId = groupToHide.attributes[ "id" ].value;

        let siblingSelector = strId.replace( strHide, strShow );

        let groupToShow = document.querySelector( "#" + siblingSelector )
        groupToShow.classList.remove( "d-none" );

        if ( 'edit' === strShow )
        {
            const firstInputFoundgroupToShow = groupToShow.querySelector( 'input' );

/*console.log(('ToggleField : firstInputFoundgroupToShow', firstInputFoundgroupToShow, groupToShow))*/;            if ( firstInputFoundgroupToShow )
            {
                firstInputFoundgroupToShow.focus();
            }
        }
    }

    showDeleteAccount ()
    {
        window.__login__.show( "delete-account" );
    }
}
